<div [formGroup]="formGroup" fxLayoutGap="1rem" fxLayout="column">

    <app-content-grid-element-display *ngIf="element != null" [element]="element"></app-content-grid-element-display>

    <div *ngIf="element == null">
        <div style="font-size: 75px; text-align: center; color: red">
            <mat-icon inline>warning</mat-icon>
        </div>
    </div>

    <button mat-stroked-button color="primary" type="button" (click)="selectMedia()"> 
        <span>Change Media...</span> 
    </button>

    <mat-form-field>
        <mat-label>Presenter Notes</mat-label>
        <textarea matInput rows="5" formControlName="notes"></textarea>
    </mat-form-field>

</div>